import type {
  EditPricelistResponse,
  OfferingType,
  PricePeriods,
  PriceBands,
  StandardOfferingDto,
  PackageOfferingDto,
} from 'app/shared/model/EditPricelist';
import { isNonFeeOffering } from '../offering/guards';
import { buildNonFeeOfferingKey } from '../offering/keys';
import type { FlatRow, FlattenDataResult } from './types';

export function buildProductFlatRows(
  products: EditPricelistResponse[],
  selectedProductType: string
): FlattenDataResult {
  const flatRows: FlatRow[] = [];
  const productRowSpans: Record<string, number> = {};
  const periodRowSpans: Record<string, number> = {};

  const source = (products || []).filter(
    (p): p is StandardOfferingDto | PackageOfferingDto =>
      isNonFeeOffering(p) &&
      (p.type === (selectedProductType as OfferingType) ||
        p.productId?.type?.name === selectedProductType) &&
      typeof p.productId?.id === 'number' &&
      Array.isArray(p.pricePeriods) &&
      p.pricePeriods.length > 0
  );

  source.forEach((product, pi) => {
    const offeringKey = buildNonFeeOfferingKey(product as any);

    const totalBands = product.pricePeriods.reduce(
      (sum: number, period: PricePeriods) => sum + (period.priceBands?.length || 0),
      0
    );

    productRowSpans[offeringKey] = totalBands;

    product.pricePeriods!.forEach((period: PricePeriods, ppi: number) => {
      if (!period.priceBands?.length) return;
      const periodKey = `${offeringKey}-${ppi}`;
      periodRowSpans[periodKey] = period.priceBands.length;

      period.priceBands.forEach((band: PriceBands, pbi: number) => {
        flatRows.push({
          key: `${offeringKey}-${ppi}-${pbi}`,
          product,
          period,
          band,
          pi,
          ppi,
          pbi,
          productRowSpan: totalBands,
          periodRowSpan: period.priceBands!.length,
        });
      });
    });
  });

  return { flatRows, productRowSpans, periodRowSpans };
}

